// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul[data-v-64c0a933]{gap:0 1em}", "",{"version":3,"sources":["webpack://./src/components/CaptionTags.vue"],"names":[],"mappings":"AACA,oBACI,SAAA","sourcesContent":["\nul\n    gap: 0 1em\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
